import superagent from 'superagent'

export const huntPlannerRightMenuBarOpen = payload => ({
    type: 'HUNT_PLANNER_RIGHT_MENU_OPEN',
    payload: payload
})

export const huntPlannerRightMenuBarClose = payload => ({
    type: 'HUNT_PLANNER_RIGHT_MENU_CLOSE',
})

export const huntPlannerRightMenuBarexpand = (payload) => ({
    type: 'HUNT_PLANNER_RIGHT_MENU_EXPAND',
    payload: payload
})

export const huntPlannerRightMenuBarHide = () => ({
    type: 'HUNT_PLANNER_RIGHT_MENU_HIDE',
})
